export const iconFontAwesomeArrowsLeftRight = (
	<i className="fa-solid fa-left-right"></i>
);
